import { type ComponentProps } from "react"
import { AlertDialog as AlertDialogBase } from "./base/AlertDialogBase"

export type AlertDialogProps = ComponentProps<typeof AlertDialogBase>

function AlertDialog(props: AlertDialogProps) {
  return <AlertDialogBase {...props} />
}

export default AlertDialog
